"use client";

import { useState } from 'react';
import FilterMenu from './navbar/FilterMenu';
import { SafeListing } from '../types';
import { HiOutlineAdjustmentsHorizontal } from 'react-icons/hi2';
import { ExchangeCurrency } from '@prisma/client';

interface FilterMenuStateProps {
    listings: SafeListing[];
    rates: ExchangeCurrency | null;
}

const FilterMenuState: React.FC<FilterMenuStateProps> = ({
    listings,
    rates
}) => {
    const [showFilters, setShowFilters] = useState(false);

    return (
        <>
            <button
                className={`
                    fixed z-[45]
                    left-4
                    top-[var(--nav-fab-offset,10.5rem)]
                    bg-white hover:bg-gray-100
                    text-gray-800
                    px-4 py-2
                    rounded-full shadow-lg
                    flex items-center gap-2
                    transition-all
                    border border-gray-300
                    ${showFilters ? 'opacity-0 pointer-events-none' : 'opacity-100'}
                `}
                onClick={() => setShowFilters(true)}
            >
                <HiOutlineAdjustmentsHorizontal size={18} />
                <span className="ml-2 hidden md:block">Filters</span>
            </button>

            {showFilters && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-50"
                    onClick={() => setShowFilters(false)}
                >
                    <div
                        className="hidden md:block absolute left-4 top-[var(--nav-fab-offset,10.5rem)] w-96 lg:w-[28rem] xl:w-[32rem] h-[calc(100vh-var(--nav-fab-offset,10.5rem)-1rem)] min-h-0 overflow-hidden"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="flex h-full min-h-0 flex-col">
                            <FilterMenu
                                listings={listings}
                                onClose={() => setShowFilters(false)}
                            />
                        </div>
                    </div>

                    <div
                        className="md:hidden absolute left-4 right-4 top-[var(--nav-fab-offset,10.5rem)] h-[calc(100vh-var(--nav-fab-offset,10.5rem)-1rem)] min-h-0 overflow-hidden"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="flex h-full min-h-0 flex-col">
                            <FilterMenu
                                listings={listings}
                                onClose={() => setShowFilters(false)}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FilterMenuState;
